import type { TableDefinition } from '../engine/tables/definition';
import { validateTableDefinition } from './tableValidation';

const STORAGE_KEY = 'bop-table-draft-v1';

export function loadSavedTable(): TableDefinition | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'null') as TableDefinition | null;
    return parsed && validateTableDefinition(parsed).length === 0 ? parsed : null;
  } catch {
    return null;
  }
}

export function saveTable(table: TableDefinition): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(table));
}

export function clearSavedTable(): void {
  localStorage.removeItem(STORAGE_KEY);
}
